import { __rest } from "tslib";
import React, { forwardRef } from "react";
import * as Icons from "../Icons";
import * as S from "./styles";
export var Button = forwardRef(function (e, a) {
  var _e$appearance = e.appearance,
      r = _e$appearance === void 0 ? "primary" : _e$appearance,
      _e$size = e.size,
      t = _e$size === void 0 ? "regular" : _e$size,
      o = e.isLoading,
      n = e.isDisabled,
      s = e.href,
      i = e.children,
      l = e.hasArrow,
      c = e.component,
      m = e.to,
      d = __rest(e, ["appearance", "size", "isLoading", "isDisabled", "href", "children", "hasArrow", "component", "to"]),
      p = o || n;

  return React.createElement(S.Button, Object.assign({
    as: s ? "a" : c || null,
    href: p ? null : s,
    appearance: r,
    size: t,
    disabled: p,
    "aria-disabled": p,
    isLoading: o,
    ref: a,
    to: m
  }, d), o ? React.createElement("div", {
    className: "loader"
  }) : React.createElement(React.Fragment, null, i, l ? React.createElement(Icons.RightCaret, null) : null));
});
export default Button;